import { parseTime } from '@/utils';

export default {
  methods: {
    handleLabel(gType, timeType, title) {
      if (!title) {
        return '-';
      }
      /* 实时：当前17时   昨日17时   上周同日同时
        天：11-25   11-18
        月：今年XX月   上年同期 */
      // 实时
      if (timeType === '101') {
        if (gType === '统计数据') {
          return `今日${title}时`;
        }
        if (gType === '对比数据') {
          return `昨日${title}时`;
        }
        if (gType === 'g3') {
          return ' 上周同时';
        }
      }
      // 周
      if (timeType === '102') {
        if (gType === '统计数据') {
          return `昨日${title}时`;
        }
        if (gType === '对比数据') {
          return `上周同日${title}时`;
        }
      }
      // 天
      if (timeType === '201' || timeType === '-1') {
        let [year, month, day] = title.split('-');
        if (!day) {
          [year, month, day] = [day, year, month];
        }
        if (gType === '统计数据') {
          return `${year ? `${year}年` : ''}${month}月${day}日`;
        }
        // 按天显示 x轴拿到的是后面7天的。 需要计算7天前面的日期
        let time = `2000/${title.replace('-', '/')}`;
        time = parseTime(new Date(time) - 1000 * 60 * 60 * 24 * 7, 'MM-dd');
        [month, day] = time.split('-');
        return `${month}月${day}日`;
      }
      // 月
      if (timeType === '301') {
        const [year, month] = title.split('-');
   
        if (gType === '统计数据') {
          return `${year}年${month}月`;
        }
        if (gType === '对比数据') {
          return `${year}年${month}月`;
        }
      }
      return '-';
    },
    // 设置颜色
    handleSettingColor() {
      // 101 2条
      // -1 1条
      // 102 3条
      // 301 2条
      if (this.form.timeType === '102' || this.form.timeType === '301') {
        this.config.legendConfig = {
          统计数据: '#DE766F',
          对比数据: '#71A3F1',
        };
      } else if (this.form.timeType === '-1') {
        this.config.legendConfig = {
          统计数据: '#DE766F',
        };
      } else if (this.form.timeType === '101') {
        this.config.legendConfig = {
          统计数据: '#DE766F',
          对比数据: '#71A3F1',
        };
        // this.config.legendConfig = ['#DE766F', '#71A3F1', '#97AF88'];
      }
    },
  },
};
